export enum DuplicableElementsIdSchemeEnum {
    "LOT", "PAR", "ORG", "CON", "TPA", "RES", "TEN"
}
